import apiClient from './apiClient'

export interface PublicHoliday {
  id: number
  date: string   // ISO yyyy-MM-dd
  name: string
}

export interface GenerateHolidaysResult {
  created: number
  skipped: number
}

export const publicHolidaysService = {
  getByYear: (year: number): Promise<PublicHoliday[]> =>
    apiClient.get<PublicHoliday[]>(`/public-holidays?year=${year}`).then(r => r.data),

  create: (date: string, name: string): Promise<PublicHoliday> =>
    apiClient.post<PublicHoliday>('/public-holidays', { date, name }).then(r => r.data),

  update: (id: number, name: string): Promise<void> =>
    apiClient.put(`/public-holidays/${id}`, { name }).then(() => undefined),

  delete: (id: number): Promise<void> =>
    apiClient.delete(`/public-holidays/${id}`).then(() => undefined),

  generate: (year: number): Promise<GenerateHolidaysResult> =>
    apiClient.post<GenerateHolidaysResult>(`/public-holidays/generate/${year}`, {}).then(r => r.data),
}
